import React, { useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ListMenu from "./ListMenu";
import { Box, Button } from "@mui/material";
import { visibilityOptions } from "../utils/utils";

const longestLabel = visibilityOptions.reduce((a, b) =>
  b.label.length > a.label.length ? b : a
).label;

const getIconForValue = (value) =>
  visibilityOptions.find((opt) => opt.value === value)?.icon || null;

const getLabelForValue = (value) =>
  visibilityOptions.find((opt) => opt.value === value)?.label || "";

const VisibilitySelector = ({ value, onChange, readOnly }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const menuOptions = visibilityOptions.map((opt) => ({
    ...opt,
    disabled: readOnly,
  }));

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const handleSelect = (selectedValue) => () => {
    if (readOnly) return;
    onChange(selectedValue);
    handleClose();
  };

  return (
    <>
      <Button
        variant="outlined"
        onClick={handleClick}
        startIcon={getIconForValue(value)}
        endIcon={<ExpandMoreIcon fontSize="16px" />}
      >
        {/* Ghost text fixes button width to the longest label */}
        <Box sx={{ position: "relative" }}>
          <Box sx={{ visibility: "hidden" }}>{longestLabel}</Box>
          <Box sx={{ position: "absolute", inset: 0 }}>
            {getLabelForValue(value)}
          </Box>
        </Box>
      </Button>

      <ListMenu
        anchorEl={anchorEl}
        onClose={handleClose}
        onSelect={handleSelect}
        options={menuOptions}
        selectedValue={value}
        title="Visibility"
      />
    </>
  );
};

export default VisibilitySelector;
